import { render, staticRenderFns } from "./UIBadge.vue?vue&type=template&id=2617146a&scoped=true"
import script from "./UIBadge.vue?vue&type=script&lang=js"
export * from "./UIBadge.vue?vue&type=script&lang=js"
import style0 from "./UIBadge.vue?vue&type=style&index=0&id=2617146a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617146a",
  null
  
)

export default component.exports